import React, { Fragment } from 'react';
import type { BoxProps } from '@mui/material/Box';
import {
  StepConnector,
  StepDot,
  StepItem,
  StepLabel,
  StepProgressRoot,
  StepState,
} from './StepProgress.styles';

export type StepProgressProps = Pick<BoxProps, 'sx'> & {
  steps: string[];
  activeIndex: number;
};

const stateOf = (index: number, activeIndex: number): StepState =>
  index < activeIndex ? 'done' : index === activeIndex ? 'active' : 'pending';

export const StepProgress = ({ steps, activeIndex, sx }: StepProgressProps) => (
  <StepProgressRoot sx={sx}>
    {steps.map((label, index) => (
      <Fragment key={label}>
        <StepItem>
          <StepDot $state={stateOf(index, activeIndex)}>{index + 1}</StepDot>
          <StepLabel variant="caption" $state={stateOf(index, activeIndex)}>
            {label}
          </StepLabel>
        </StepItem>
        {index < steps.length - 1 && <StepConnector $filled={index < activeIndex} />}
      </Fragment>
    ))}
  </StepProgressRoot>
);
